import Swiper, { Navigation, Autoplay, EffectFade, A11y } from 'swiper'

const home = document.querySelector('.front-page') !== null;

if(home) {
    
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if(homeSlideshow){
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ Autoplay, A11y ]);
        
        let config = {
            effect : 'slide',
            grabCursor : 'true',
            speed: 3000,
            loop : false,

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            }
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
        }
    }

    // Slider posts
    const postsSlideshow = document.querySelector('.posts .swiper-container') !== null;
            
    if (postsSlideshow) {
        let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

        Swiper.use([ Navigation, A11y ]);

        let postsConfig = {
            grabCursor : 'true',
            speed: 700,
            loop : false,

            fadeEffect: {
                crossFade: true
            },
        
            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true, 
            },

            navigation: {
                nextEl: `.posts .swiper-button-next`,
                prevEl: `.posts .swiper-button-prev`,
            },

            breakpoints: {
                1201 : {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                961 : {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                641 : {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                0 : {
                    slidesPerView: 1,
                    spaceBetween: 20,
                }
            }
        }
        
        if(postsSlides > 3){
            let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
        }

    }

    // Slider Fil d'infos
    const alerteSlideshow = document.querySelector('.alerte .swiper-container') !== null;
            
    if (alerteSlideshow) {
        let alerteSlides = document.querySelectorAll('.alerte .swiper-container .swiper-slide').length;

        Swiper.use([ Navigation, EffectFade, A11y ]);

        let alerteConfig = {
            effect : 'fade',
            grabCursor : 'true',
            speed: 700,
            loop : true,
            slidesPerView: 1,
            spaceBetween: 30,

            fadeEffect: {
                crossFade: true
            },
        
            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true, 
            },

            navigation: {
                nextEl: `.alerte__navigation .swiper-button-next`,
                prevEl: `.alerte__navigation .swiper-button-prev`,
            }
        }
        
        if(alerteSlides > 1){
            let swiperAlerte = new Swiper('.alerte .swiper-container', alerteConfig);
        }

    }

    /*** Kiosque ***/
    const kiosqueSlideshow = document.querySelector('.kiosque .swiper-container') !== null;
            
    if (kiosqueSlideshow) {
        let kiosqueSlides = document.querySelectorAll('.kiosque .swiper-container .swiper-slide').length;

        Swiper.use([ Navigation, A11y ]);

        let kiosqueConfig = {
            effect: 'slide',
            grabCursor : 'true',
            loop: false,

            navigation: {
                nextEl: `.kiosque__navigation .swiper-button-next`,
                prevEl: `.kiosque__navigation .swiper-button-prev`,
            },

            breakpoints: {
                1201: {
                    spaceBetween: 70,
                    slidesPerView: 2,
                },
                961: {
                    spaceBetween: 35,
                    slidesPerView: 2,
                },
                641: {
                    spaceBetween: 80,
                    slidesPerView: 2,
                },
                0: {
                    spaceBetween: 80,
                    slidesPerView: 1,
                }
            }

        }
        if(kiosqueSlides > 2) {
            let swiperKiosque = new Swiper('.kiosque .swiper-container', kiosqueConfig);
        }
    }

    /*** Projets ***/
    const projetsSlideshow = document.querySelector('.projets__swiper .swiper-container') !== null;
            
    if (projetsSlideshow) {
        let projetsSlides = document.querySelectorAll('.projets__swiper .swiper-container .swiper-slide').length;

        Swiper.use([ Navigation, EffectFade, A11y ]);

        let projetsConfig = {
            effect: 'fade',
            grabCursor : 'true',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,

            navigation: {
                nextEl: `.projets__navigation .swiper-button-next`,
                prevEl: `.projets__navigation .swiper-button-prev`,
            }
        }
        if(projetsSlides > 1) {
            let swiperProjets = new Swiper('.projets__swiper .swiper-container', projetsConfig);
        }
    }

    /*** Raisons ***/
    const raisonsSlideshow = document.querySelector('.raisons .swiper-container') !== null;
            
    if (raisonsSlideshow) {
        let raisonsSlides = document.querySelectorAll('.raisons .swiper-container .swiper-slide').length;
    
        Swiper.use([ Navigation, EffectFade, Autoplay, A11y ]);

        let raisonsConfig = {
            effect: 'fade',
            grabCursor : 'true',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
             autoplay: {
                delay: 3500,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl: `.raisons__navigation .swiper-button-next`,
                prevEl: `.raisons__navigation .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            }
        };

        if(raisonsSlides > 1) {
            let swiperRaisons = new Swiper('.raisons .swiper-container', raisonsConfig);

            let boutonOnOff = document.getElementById('boutonOnOff');

            boutonOnOff.addEventListener('click', function () {

                if(swiperRaisons.autoplay.running === true) {
                    swiperRaisons.autoplay.stop();

                    boutonOnOff.classList.remove('swiper-button--on')
                    boutonOnOff.classList.add('swiper-button--off');
                    console.log(swiperRaisons.autoplay.running);
                }
                else {
                    swiperRaisons.autoplay.start();

                    boutonOnOff.classList.remove('swiper-button--off')
                    boutonOnOff.classList.add('swiper-button--on');
                    console.log(swiperRaisons.autoplay.running);
                }
            });

            swiperRaisons.on('transitionEnd', function() {
                let currentIndex = document.querySelector('.swiper-counter .current');
                currentIndex.innerHTML = swiperRaisons.realIndex + 1;
            });
        }
    }
}